import { Component, OnInit, ViewChild } from '@angular/core';
import { SplitComponent } from 'angular-split';
import samples_docs from "../../assets/samples.json";
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { DocService } from '../services/doc.service';

export class SampleNode {

    public get file(): string {
        return this._file;
    }
    public get path(): string {
        return this._path;
    }
    constructor(protected _file: string, protected _path: string) {
    }
}

interface Samp {
	name: string;
	children?: Samp[];
	content?: string;
}
  
@Component({
	selector: 'samples-component',
	templateUrl: './samples.component.html',
	styleUrls: ['./samples.component.scss']
})
export class SamplesComponent implements OnInit {
	@ViewChild('splitter', { static: false }) _splitterComponent: SplitComponent;
	Samples: SampleNode[] = [];
	samps: Samp[] = [];
	SelectedSample: string = '';
	SelectedContent: string = '';
	treeControl = new NestedTreeControl<Samp>(node => node.children);
  	dataSource = new MatTreeNestedDataSource<Samp>();
	searchFileHierarchy : Samp[] = []

	constructor(private _docService: DocService) {
		this._docService.ShowSamplesLink = true;
		for (let sample of samples_docs) {
			this.samps.push(sample as Samp);
		}
		this.dataSource.data = this.samps;
		this.searchFileHierarchy = this.samps;
		this.treeControl.expand(this.samps[0]);
		this.SelectedSample = this.samps[0].children[0].name;
		this.SelectedContent = this.samps[0].children[0].content;
	 }

	ngOnInit() {
		for (let key of Object.keys(samples_docs)) {
			this.Samples.push( new SampleNode(this.getFileFromPath(key), key));
		}

		this.Samples.sort((a, b) => a.file < b.file ? -1 : a.file > b.file ? 1 : 0);
	}

	ngOnDestroy() {
		this._docService.ShowSamplesLink = false;
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this._splitterComponent.direction = 'horizontal';
			this._splitterComponent.disabled = false;
		});
	}

	onSampleSelect(e: MouseEvent, item: any) {
		e.stopPropagation();
		this.SelectedSample = item.path;
		this.SelectedContent = samples_docs[this.SelectedSample];
	}

	getFileFromPath(path: string): string {
		const split = path.split('.');
		const count = split.length;
		return split[count - 2] + '.' + split[count - 1];
	}

	hasChild = (_: number, node: Samp) => !!node.children && node.children.length > 0;

	onFileSelect(node: Samp) {
		this.SelectedSample = node.name;
		this.SelectedContent = node.content;
	}

	searchSamplesTree(value: string) {
		let searchFileHierarchy = [];
		if (value == '') {
			this.dataSource.data = this.samps;
			this.searchFileHierarchy = this.samps;
			this.treeControl.collapseAll();
			this.treeControl.expand(this.samps[0]);
			this.SelectedSample = this.samps[0].children[0].name;
			this.SelectedContent = this.samps[0].children[0].content;
			return
		}
		else {
			for (let node of this.samps) {
				let searchresult: any = this.includeInSearchResult(node, value);
				if (searchresult != null)
					searchFileHierarchy.push(searchresult);
			}
		}
		if (searchFileHierarchy.length > 0) {
			this.dataSource.data = searchFileHierarchy;
			this.treeControl.dataNodes = searchFileHierarchy;
			this.treeControl.expandAll();
		}
		this.searchFileHierarchy = searchFileHierarchy;
	}

	includeInSearchResult (node: Samp, value: string) {
		let temp_children: Samp[] = []; 
		let temp_node : Samp = {name: node.name, children: temp_children};
		if (node.name.toLocaleLowerCase().includes(value.toLocaleLowerCase()) && !('children' in node))
			return node;
		if ('children' in node) {
			for (let child of node.children) {
				let result: any = this.includeInSearchResult(child, value);
				if (result != null)
					temp_children.push(result);
			}
		}
		return temp_children.length != 0 ? temp_node : null;
	}

	isSampleSelected(node: Samp) {
		return node.name == this.SelectedSample;
	}

	isTreeEmpty() {
		return this.searchFileHierarchy.length == 0;
	}
}
